"use strict";
/**
 * Created by SH 16/03/2019
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresentationController = void 0;
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const Presentation_1 = require("./Presentation");
const gsap_1 = require("gsap");
const EventHandler_1 = require("../../event/EventHandler");
const StageEvent_1 = require("../../stage/event/StageEvent");
const StageManager_1 = require("../../stage/StageManager");
const Helper_1 = require("../../utils/Helper");
class PresentationController {
    constructor(config, _checkLogs) {
        this.checkLogs = false;
        this._hasInit = false;
        this.checkLogs = !!_checkLogs;
        this.config = config;
        this.addBaseEventListeners();
    }
    addBaseEventListeners() {
        EventHandler_1.EventHandler.addEventListener(this, StageEvent_1.StageEvent.STAGE_RESIZED, (event) => this.onStageResized(event.params[0]));
    }
    get gotActivePresentation() {
        return !!this._lockedPresentation;
    }
    get activePresenation() {
        try {
            return this._lockedPresentation;
        }
        catch (_a) {
            throw "Error in StateSystem! Contact SH with [CODE 7].";
        }
    }
    get eventType() {
        return this.config.eventType;
    }
    get needResult() {
        return !!this.config.resultParsed;
    }
    isEventList(type) {
        return type === this.config.eventType;
    }
    // Give data to all presentations in the list for activation evaluation.
    Start(cb) {
        this._callBack = cb;
        this.isAnyActive();
    }
    // Find an activated presentation.
    isAnyActive() {
        this.checkLogs && Logger_1.Logger.log("[PresC] Check if any presentation is active.");
        this.getActivateAble() ? this.beforeStarting() : this.finish();
    }
    tryInitialize() {
        for (let i = 0; i < this.config.presentations.length; i++) {
            const presentation = this.config.presentations[i];
            if (presentation.initialization) {
                if (presentation.presentationConfig != undefined && presentation.presentationConfig.layer)
                    StageManager_1.StageManager.getLayer(presentation.presentationConfig.layer).addChild(presentation);
                presentation.initialization();
            }
        }
        this._hasInit = true;
    }
    // Calls the manager for activating the callback when all presentations are done.
    finish() {
        this.checkLogs && Logger_1.Logger.log("[PresC] No presentation is active, finishing.");
        if (this._callBack) {
            this._callBack();
            delete this._callBack;
        }
    }
    onInitGameData(data) {
        if (!data)
            return;
        for (let i = 0; i < this.config.presentations.length; i++) {
            if (this.config.presentations[i].setParsedInitData)
                this.config.presentations[i].setParsedInitData(data);
        }
    }
    onGameDataParsed(data) {
        if (!data)
            return;
        this.checkLogs && Logger_1.Logger.log("[PresC] Data is being parsed for event: " + this.eventType);
        for (let i = 0; i < this.config.presentations.length; i++) {
            const presentation = this.config.presentations[i];
            if (presentation.checkForActivation(data)) {
                // Sets the presentation state to activated due to it passed the check.
                this.checkLogs && console.log("[PresC] Parsing data to activated presentation on list ID: " + i);
                presentation.PresentationState.set(Presentation_1.PresentationState.ACTIVATED);
                if (presentation.setParsedGamedData)
                    presentation.setParsedGamedData(data);
                if (presentation.isActive()) {
                    this.checkLogs && console.log(presentation);
                    this.checkLogs && Logger_1.Logger.log("[PresC] Presentation got activated threw DataParsed");
                }
            }
            ;
        }
        this.checkLogs && Logger_1.Logger.log("[PresC] Data parsed for event" + this.eventType);
    }
    getActivateAble() {
        this._lockedPresentation = this.findActive();
        return this.gotActivePresentation;
    }
    findActive() {
        return this.config.presentations.find((p) => { return p.isActive(); });
    }
    findEnding() {
        this._lockedPresentation = this.config.presentations.find((p) => { return p.PresentationState.isEndState; });
        return this.gotActivePresentation;
    }
    beforeStarting() {
        new Promise((resolve) => {
            if (this.activePresenation.preStart)
                this.activePresenation.preStart();
            resolve();
        }).then(() => this.startPresentation());
    }
    /*****/
    // Playlist that is being called and managed in order.
    startPresentation() {
        this.activePresenation.pTimeline = Helper_1.Helper.timeLineKiller(this.activePresenation.pTimeline, new gsap_1.TimelineMax({
            paused: true,
            onComplete: () => { this.doMultiPresenation(); }
        }));
        this.fetchPresentation();
    }
    fetchPresentation() {
        if (this.activePresenation.PresentationState.isEndState && this.activePresenation.endPresentation)
            this.activePresenation.endPresentation();
        else
            this.activePresenation.getPresentation();
        if (this.activePresenation.presentationConfig) {
            this.checkLogs && Logger_1.Logger.log("Presentation: " + this.activePresenation.presentationConfig.name + " Plays.");
        }
        // Play Animation.
        this.activePresenation.pTimeline.play();
    }
    // This is needed if we want to do an multiple state loop.
    doMultiPresenation() {
        this.checkLogs && Logger_1.Logger.log("[PresC] Check if Sync is needed or if it's still active.");
        if (this.checkSync() || this.isStillActive()) {
            this.checkLogs && Logger_1.Logger.log("[PresC] Sync Needed:" + this.checkSync());
            this.checkLogs && Logger_1.Logger.log("[PresC] Still Active:" + this.isStillActive());
            this.startPresentation();
        }
        else {
            this.checkLogs && Logger_1.Logger.log("[PresC]Triggering StopPresentation.");
            this.stopPresentation();
            this.isAnyActive();
        }
    }
    checkSync() {
        return !!this.activePresenation.promiseSync && !this.activePresenation.promiseSync();
    }
    isStillActive() {
        return this.activePresenation.isActive();
    }
    stopPresentation() {
        if (this.activePresenation.stopPresentation)
            this.activePresenation.stopPresentation();
    }
    playEnd(cb) {
        Logger_1.Logger.logDev(`Presentation Event: ${this.config.eventType} End.`);
        this.activePresenation.pTimeline = Helper_1.Helper.timeLineKiller(this.activePresenation.pTimeline, new gsap_1.TimelineMax({ onComplete: () => cb() }));
        this.fetchPresentation();
    }
    skip() {
        if (this._lockedPresentation && this.activePresenation.skipPresentation) {
            this.activePresenation.skipPresentation();
            return true;
        }
        return false;
    }
    onStageResized(resizeData) {
        if (this._hasInit) {
            for (let i = 0; i < this.config.presentations.length; i++) {
                if (this.config.presentations[i].onResize)
                    this.config.presentations[i].onResize(resizeData);
            }
        }
    }
}
exports.PresentationController = PresentationController;
//# sourceMappingURL=PresentationController.js.map